module.exports = __webpack_public_path__ + "static/media/Stars-BG.170e3fe1.png";